import React, {  useState } from "react";
import * as Yup from "yup";
import ReactSelect from "../../components/FormikControl/ReactSelect";

import Form from "@Components/Form";
import { URLS, NATIONALITIES_FAV_LIST_URL } from "configs/constants";

import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

let API_URL = "user-contract/";

const SUPPORTING_DOCUMENT_FORMATS = [
  "application/pdf",
  
];
const validationSchema = Yup.object({
  language: Yup.string()
    .required("Language is required")
    .typeError("Invalid language"),
  nationality: Yup.array()
  .min(1, "No Nationality selected")
    .required("Nationality is required")
    .typeError("Invalid nationality"),
    status: Yup.string()
    .required("Status is required")
    .typeError("Status is required"),
  contract_file: Yup.mixed().test(
    "fileType",
    "Unsupported file type",
    (value) => {
      if (value === null) {
        return true;
      } else if (typeof value === "string") {
        return true;
      } else {
        return SUPPORTING_DOCUMENT_FORMATS.includes(value.type);
      }
    }
  ),
});
const ContractUpload = () => {
  const [selectedLangauge, setSelectedLanguage] = useState('English');
  const { t } = useTranslation();
  const params = useParams();
  const [selecteddefaultValue, setSelectedDefaultValue] = useState("No");

  const initialValues = {
    language: "",
    is_default: selecteddefaultValue,
    status: "",
    nationality: "",
    contract_file: null,
  };

  //condition for default value if the languauge is english

  const getLanguage = (e) => {
    console.log("get language called", e);
    if(e?.value == "English"){
      setSelectedLanguage(e?.value);
      setSelectedDefaultValue("Yes");

    }
    else{
      setSelectedLanguage(e?.value);
      setSelectedDefaultValue("No");


    }
  };

  const formFields = [
    { type: "title", title: "Worker Contract T&C" },
    {
      type: "reactselect",
      name: "language",
      label: "Document Language",
      outerOptions: [
        {
          id: "Bahasa Malaysia",
          name: "Bahasa Malaysia",
          value: "Bahasa Malaysia",
        },
        { id: "Bengali", name: "Bengali", value: "Bengali" },
        { id: "Burmese", name: "Burmese", value: "Burmese" },
        { id: "English", name: "English", value: "English" },
        { id: "Indonesia", name: "Indonesia", value: "Indonesia" },
        { id: "Nepali", name: "Nepali", value: "Nepali" },
        { id: "Tamil", name: "Tamil", value: "Tamil" },
        { id: "Thai", name: "Thai", value: "Thai" },
      ],
      getValue: getLanguage,
      required: true,
    },
    {
      type: "renderonly",
      name: "is_default",
      label: "Default",
      value: selecteddefaultValue,
       required: false,
    },
    {
      type: "reactselect",
      name: "status",
      label: "Status",
      outerOptions: [
        {
          id: "Active",
          name: "Active",
          value: "Active",
        },
        {
          id: "Inactive",
          name: "Inactive",
          value: "Inactive",
        },
      ],
      required: true,
    },
    
    {
      type: "component",
      name: "nationality",
      label: "Nationality",
      required: true,
      proxyUrl: NATIONALITIES_FAV_LIST_URL,
      paginated: false,
      groupedOptions: true,
      component: ReactSelect,
      isMultiSelect: true,
      id:params.id,
      gridSize: { xs: 12, sm: 6 },
      nationalityInfoIcon: true,

    },
    {
      type: "fileupload",
      name: "contract_file",
      key: "contract_file",
      accept: ".pdf",
      label: "Contract T&C",
      supportedTypes: [t("pdf format only")], //info icon message pop up
      supportedFormat: "application/pdf", //validation error message
      required: true,
    },
  ];

  const formButtons = ["submit", "cancel"];
  return (
    <Form
      initialValues={initialValues}
      validationSchema={validationSchema}
      submitUrl={API_URL}
      listRoute={URLS.WORKER_CONTRACT_LIST}
      formFields={formFields}
      formButtons={formButtons}
      isMultipart
      formTitle="Worker Contract Upload"
    />
  );
};

export default ContractUpload;
